var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerCur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 65",
    style: {
      enableBackground: "new 0 0 50 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3AA757;}\n\t.st1{fill:#2376E5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,36.84c-6.54,0-11.84-5.3-11.84-11.84c0-6.54,5.3-11.84,11.84-11.84c6.54,0,11.84,5.3,11.84,11.84 C36.84,31.54,31.54,36.84,25,36.84L25,36.84z M25,0C11.19,0,0,11.19,0,25c0,3.29,0.64,6.43,1.79,9.31 c0.32,0.75,0.67,1.51,1.04,2.27C7.27,45.63,15.08,55.38,25,65c9.92-9.62,17.74-19.38,22.17-28.43c0.37-0.76,0.72-1.51,1.04-2.26 C49.36,31.43,50,28.29,50,25C50,11.19,38.81,0,25,0L25,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCur);
export default __webpack_public_path__ + "static/media/markerCur.e485432010eb901a3a1d8f00c7a2ea91.svg";
export { ForwardRef as ReactComponent };